import { Vector3 } from 'three';
import { SceneData } from '../../../atoms/scene';


const scenes_scenario_82: { [key: string]: SceneData } = {
	'scene_01': {
		camera_settings: {
			position: new Vector3(-10, 1.6, -1.8),
			target: new Vector3(-9.6, 1.18, 0.3)
		},

		objects: {
			'22': {
				type: 'character',
				position: new Vector3(-9.7, 0, 0.3),
				rotation: [0, 34.6, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'10': {
				type: 'character',
				position: new Vector3(-10.35, 0, .6),
				rotation: [0, 170 * (Math.PI / 180), 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'15': {
				type: 'character',
				position: new Vector3(-8.9, -0.42, 0.1),
				rotation: [0, 35.1, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'6': {
				type: 'character',
				position: new Vector3(-7.85, -0.42, 0),
				rotation: [0, 35.3, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'5': {
				type: 'character',
				position: new Vector3(-8.6, -0.42, -1.21),
				rotation: [0, 0, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'3': {
				type: 'character',
				position: new Vector3(-9.2, -5, 0.6),
				rotation: [0, 34.5, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'12': {
				type: 'character',
				position: new Vector3(-7.5, 0, 0.6),
				rotation: [0, 35.6, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',,
			},
			'4': {
				type: 'character',
				position: new Vector3(-10.2, 0, 1.3),
				rotation: [0, 170 * (Math.PI / 180), 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},

		},
	},
	'spirith_s3_ada': {
		camera_settings: {
			position: new Vector3(-10, 1.6, -1.8),
			target: new Vector3(-9.6, 1.18, 0.3)
		},

		objects: {
			'22': {
				type: 'character',
				position: new Vector3(-9.7, 0, 0.3),
				rotation: [0, 34.6, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'10': {
				type: 'character',
				position: new Vector3(-10.5, 0, -0.1),
				rotation: [0, 33.5, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'15': {
				type: 'character',
				position: new Vector3(-8.9, -0.42, 0.1),
				rotation: [0, 35.1, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'6': {
				type: 'character',
				position: new Vector3(-7.85, -0.42, 0),
				rotation: [0, 35.3, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'5': {
				type: 'character',
				position: new Vector3(-8.6, -0.42, -1.21),
				rotation: [0, 0, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'3': {
				type: 'character',
				position: new Vector3(-9.2, -5, 0.6),
				rotation: [0, 34.5, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'12': {
				type: 'character',
				position: new Vector3(-7.5, 0, 0.6),
				rotation: [0, 35.6, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',,
			},
			'4': {
				type: 'character',
				position: new Vector3(-10.3, 0, 0.6),
				rotation: [0, 34, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
		},

	},

	'spirith_s3_orion_out': {
		camera_settings: {
			position: new Vector3(-9.473860476335899, 1.6, 2.5989320273729803),
			target: new Vector3(-10, 1.6, 2.5)
		},

		objects: {
			'10': {
				type: 'character',
				position: new Vector3(-10.5, 0, 1.4),
				rotation: [0, 0.7, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'22': {
				type: 'character',
				position: new Vector3(-10.6, 0, 2.5),
				rotation: [0, 1.4, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',			
			},
			'4': {
				type: 'character',
				position: new Vector3(-11, 0, 3.5),
				rotation: [0, 2.1, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
		},

	},

	'spirith_s3_orion': {
		camera_settings: {
			position: new Vector3(-11.6, 1.6, 0.64),
			target: new Vector3(-15, 1.5, -3)
		},

		objects: {
			'10': {
				type: 'character',
				position: new Vector3(-12, 0, -1.5),
				rotation: [0, -0.1, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'22': {
				type: 'character',
				position: new Vector3(-13.2, 0, 0.5),
				rotation: [0, 1.5, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',			
			},
			'4': {
				type: 'character',
				position: new Vector3(-13, 0, -1.5),
				rotation: [0, 0.6, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
		},

	},


	'spirith_s3_atlas_out': {
		camera_settings: {
			position: new Vector3(-11, 1.6, 2),
			target: new Vector3(-8.2, 1.5, 0.1)
		},

		objects: {
			'15': {
				type: 'character',
				position: new Vector3(-8.88, -0.42, 0),
				rotation: [0, 34.5, 0],
				sitting: true,
				idle: 'idle_sitting_desk',
			},
			'5': {
				type: 'character',
				position: new Vector3(-8.6, -0.42, -1.21),
				rotation: [0, 0, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'12': {
				type: 'character',
				position: new Vector3(-7.6, -0.42, -1.21),
				rotation: [0, 0, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'6': {
				type: 'character',
				position: new Vector3(-7.85, -0.42, 0),
				rotation: [0, 34.5, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
		},

	},

	'spirith_s3_atlas': {
		camera_settings: {
			position: new Vector3(-10.2, 1.6, 0.),
			target: new Vector3(-7.9, 1, -0.5)
		},

		objects: {
			'15': {
				type: 'character',
				position: new Vector3(-8.88, -0.42, 0),
				rotation: [0, 35, 0],
				sitting: true,
				idle: 'idle_sitting_desk',
			},
			'5': {
				type: 'character',
				position: new Vector3(-8.6, -0.42, -1.21),
				rotation: [0, -0.8, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'12': {
				type: 'character',
				position: new Vector3(-7.6, -0.42, -1.21),
				rotation: [0, 0, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'6': {
				type: 'character',
				position: new Vector3(-7.85, -0.42, 0),
				rotation: [0, 34.5, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
		},

	},

	'spirith_s3_balie': {
		camera_settings: {
			position: new Vector3(-0.8, 1.6, 3.2),
			target: new Vector3(-0.3, 1.3, 1.5

			)
		},

		objects: {
			'22': {
				type: 'character',
				position: new Vector3(-0.3, 0, 1.5),
				rotation: [0, -0.3, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},

			'15': {
				type: 'character',
				position: new Vector3(-7.9, -0.42, 0.1),
				rotation: [0, 35.1, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			},
			'5': {
				type: 'character',
				position: new Vector3(-7.66, -0.42, -1.21),
				rotation: [0, 0, 0],
				sitting: true,
				idle: 'idle_sitting_lap',
			}
		},

	},

};

export default scenes_scenario_82;

